import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import landingBackground from '../../assets/backgrounds/landingBackground.avif';
import { GOLDEN_MINOR } from '../../styles/golden';
import { BRAND, glassCardSx } from '../../styles/ui';
import SiteFooter from './SiteFooter';
import SiteHeader, { HomeButton } from './SiteHeader';

interface PageLayoutProps {
  title: string;
  subtitle?: ReactNode;
  headerActions?: ReactNode;
  children: ReactNode;
}

// Reading pages (contact, privacy, terms): header, a titled card at a comfortable line length, footer
const PageLayout: React.FC<PageLayoutProps> = ({ title, subtitle, headerActions, children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'var(--joan-bg)',
      backgroundImage: {
        xs: `linear-gradient(${BRAND.veilFull}, ${BRAND.veilFull}), url(${landingBackground})`,
        md: `linear-gradient(to right, ${BRAND.veilStrong} ${GOLDEN_MINOR}, ${BRAND.veilSoft} 100%), url(${landingBackground})`
      },
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: { md: 'fixed' }
    }}
  >
    <SiteHeader actions={headerActions ?? <HomeButton iconOnlyOnPhone />} />

    <Box component="main" sx={{ flex: 1, px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 } }}>
      <Box sx={{ maxWidth: 760, mx: 'auto' }}>
        <Typography variant="h4" component="h1" sx={{ color: BRAND.ink, mb: subtitle ? 2 : 4, px: { xs: 1, sm: 0 } }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" sx={{ color: BRAND.muted, mb: 4, px: { xs: 1, sm: 0 } }}>
            {subtitle}
          </Typography>
        )}
        <Box sx={{ ...glassCardSx, mb: 0 }}>{children}</Box>
      </Box>
    </Box>

    <SiteFooter />
  </Box>
);

export default PageLayout;
